import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import PageWrapper from "../components/PageWrapper";
import "./AdsApi.css";

export default function AdsApi() {
  return (
    <PageWrapper>
      <div className="ads-api-container">
        <h1>MindBlows — Google Ads API</h1>
        <p className="ads-api-lead">
          This page describes who we are and how we use the Google Ads API. It
          is intended for Google’s API access review as well as anyone who wants
          to understand our advertising setup.
        </p>

        <h2>Company</h2>
        <p>
          <strong>MindBlows</strong> is an independent mobile studio based in
          Israel. We develop and publish our own apps for iOS
          and Android. We are not an advertising agency and we do not manage
          Google Ads accounts for other companies or the general public.
        </p>
        <ul>
          <li>
            Website:{" "}
            <a href="https://mindblows.com">https://mindblows.com</a>
          </li>
          <li>
            About: <Link to="/about">mindblows.com/about</Link>
          </li>
          <li>
            Apps: <Link to="/apps">mindblows.com/apps</Link>
          </li>
          <li>
            App Store developer:{" "}
            <a
              href="https://apps.apple.com/lu/developer/sivan-gants/id1241647691"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sivan Gants / MindBlows
            </a>
          </li>
          <li>
            Google Play developer:{" "}
            <a
              href="https://play.google.com/store/apps/dev?id=6936898117969072451"
              target="_blank"
              rel="noopener noreferrer"
            >
              MindBlows on Google Play
            </a>
          </li>
          <li>
            Contact:{" "}
            <a href="mailto:hello@mindblows.com">hello@mindblows.com</a>
          </li>
        </ul>

        <h2>Example of our own apps</h2>
        <ul>
          <li>
            Driving Theory Test 2026 (Theory Easy) —{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.mindblows.theory"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play
            </a>
          </li>
          <li>
            Volcano — Tropical Word Game —{" "}
            <a
              href="https://play.google.com/store/apps/details?id=tomerrubin.com.volcano"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play
            </a>
          </li>
        </ul>

        <h2>Internal tool (App Factory)</h2>
        <p>
          We operate an internal operations tool called <strong>App Factory</strong>{" "}
          (macOS dashboard used by MindBlows staff only). It helps us publish our
          own apps and run user-acquisition campaigns for those apps. It is not
          sold, licensed, or offered as a product to advertisers, agencies, or
          end users.
        </p>

        <h2>Intended Google Ads API use</h2>
        <p>
          We request Google Ads API <strong>Basic Access</strong> so App Factory
          can talk to <em>our</em> Google Ads manager and client accounts. Scope
          is limited to:
        </p>
        <ul>
          <li>
            Creating and managing <strong>App campaigns</strong> for MindBlows
            apps (paused by default until an operator approves spend)
          </li>
          <li>Reading campaign performance (spend, clicks, installs)</li>
          <li>
            Enabling Firebase / Google Analytics <code>first_open</code>{" "}
            conversion actions on our linked properties so App campaigns can
            optimize to installs
          </li>
        </ul>
        <p>
          Authentication uses OAuth with the{" "}
          <code>https://www.googleapis.com/auth/adwords</code> scope against our
          manager account. We do not use this application for the separate App
          Conversion Tracking and Remarketing partner-token path. We do not
          scrape unrelated accounts or offer API access to third parties.
        </p>

        <h2>Who has access</h2>
        <p>
          Internal users only — MindBlows employees and contractors operating our
          own Ads accounts. External users and clients cannot use the tool.
        </p>
      </div>
      <Footer />
    </PageWrapper>
  );
}
